import { render } from "./EditPaymentType.vue?vue&type=template&id=a35d131c&scoped=true"
import script from "./EditPaymentType.vue?vue&type=script&lang=js"
export * from "./EditPaymentType.vue?vue&type=script&lang=js"

import "./EditPaymentType.vue?vue&type=style&index=0&id=a35d131c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a35d131c"]])

export default __exports__